<template>
  <div class="new-layout">
    <div class="new-layout-bg">
      <div class="new-content">
        <div  class="title">地平线计划——用脚步丈量公益，以行动点亮希望
        </div>
        <div style="color: rgba(80, 80, 80, 0.7);margin-top: 6px" >2025年05月15日 18:11 贵州</div>
        <div class="content">
          <img class="new-icon" src="../../assets/news_image1.jpeg">
          <div class="ds-ct">
            我们是一群热爱运动、热衷公益的企业家和爱心人士，因共同的信念汇聚成“地平线计划”——超越极限的脚步，永不落山的公益。
          </div>
         <div class="big-ds">
           我们是谁？
         </div>
          <div class="ds-ct">
            从马拉松赛道到戈壁荒漠，从城市到乡村，我们用奔跑者的坚韧践行公益。
          </div>

          <div class="big-ds">
            我们做什么？
          </div>
          <div class="mid-ds">
            1. 点亮乡村
          </div>
          <div class="ds-ct">
            在四川凉山佐戈依达村，我们捐赠120盏太阳能路灯，解决2200名村民的夜间出行难题。从灯杆组装到调试亮灯，与村民携手完成，让“路灯亮了，世界就亮了”成为现实。
          </div>
          <div class="mid-ds">
            2. 温暖教育
          </div>
          <div class="ds-ct">
            走进美姑县塔哈村小学，为支教老师和学生送去运动装备、学习物资，用行动支持乡村教育，守护孩子的梦想。
          </div>
          <div class="mid-ds">
            3. 永不止步
          </div>
          <div class="ds-ct">
            公益如长跑，需持久耐力。我们以“运动+公益”的方式，将挑战自我的精神转化为帮扶他人的力量——爱运动、跑马拉松、走戈壁、做公益，每一步都奔向更远的地平线。
          </div>

          <div class="big-ds">
            为什么是“地平线”？
          </div>
          <div class="ds-ct">
            地平线是远方，是希望，是永不停歇的追寻。
          </div>
          <div class="mid-ds">
            超越极限:
          </div>
          <div class="ds-ct">
            如同马拉松，公益需要突破地域与资源的限制。
          </div>
          <div class="mid-ds">
            永不落幕:
          </div>
          <div class="ds-ct">
            像太阳始终在地平线升起，我们的行动持续温暖每一处角落。
          </div>
          <img class="new-icon" src="../../assets/news_image2.jpeg">
          <div class="ds-ct">
            加入我们，无论是企业合作、物资捐赠，还是成为志愿者，您的每一份力量都能让地平线更明亮。
          </div>
          <div class="ds-ct">
            关注我们，一起奔跑，为公益续航！
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      statusBarHeight: 60,
    };

  },

  methods: {


    back() {
      window.history.back(-1);
    },
  },
  mounted() {


  },
};

</script>

<style lang="scss" scoped>
.new-layout {

  position: relative;

  .new-layout-bg {
    background: #F0F4FF;
    position: relative;

  }


  .correlation-new {
    background: #ffffff;
    padding: 10px;
    padding-bottom: 0;
    margin-top: 10px;


    .correlation-new-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      padding-top: 6px;
      //padding-bottom: 14px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;

      .mark-view {
        height: 19px;
        width: 2px;
        border-radius: 5px;
        background: #3E74F8;
      }

      .dels {
        margin-left: 6px;
      }
    }
  }

  .new-content {

    background: #ffffff;
    color: #333333;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    flex-direction:column;







    .content {
      padding-top: 16px;
      padding-bottom: 16px;
      letter-spacing: 0;
      line-height: 26px;
      text-align: center;
      .ds-ct{
        text-align: justify;
      }
      .big-ds{
        text-align: justify;
        font-weight: bold;
        font-size: 17px;
      }
      .mid-ds{
        text-align: justify;
        font-weight: bold;
      }


      .new-icon {
        text-align: justify;
        width: 80%;
        border-radius: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
      }

    }

    .title {
      margin-top: 30px;
      font-size: 20px;
      font-weight: bold;
    }

  }


}
</style>
